import { render } from "./ChargeDetailView.vue?vue&type=template&id=6b122368"
import script from "./ChargeDetailView.vue?vue&type=script&lang=js"
export * from "./ChargeDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__